(function (window, document) {
  "use strict";

  var STORAGE_KEY = "lbh:categoryViews";
  var STORAGE_VERSION_KEY = "lbh:categoryViews:v";
  var CURRENT_VERSION = 1;

  function storageAvailable() {
    try {
      var testKey = "__lbh_test__";
      window.localStorage.setItem(testKey, "1");
      window.localStorage.removeItem(testKey);
      return true;
    } catch (e) {
      return false;
    }
  }

  function readTally() {
    if (!storageAvailable()) return {};
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return {};
      var parsed = JSON.parse(raw);
      if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) {
        return {};
      }
      return parsed;
    } catch (e) {
      return {};
    }
  }

  function writeTally(tally) {
    if (!storageAvailable()) return;
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(tally));
      window.localStorage.setItem(STORAGE_VERSION_KEY, String(CURRENT_VERSION));
    } catch (e) {}
  }

  function normalizeCategory(rawType) {
    if (!rawType || typeof rawType !== "string") return null;
    var trimmed = rawType.trim();
    if (!trimmed) return null;
    return trimmed
      .toLowerCase()
      .replace(/\b\w/g, function (c) {
        return c.toUpperCase();
      });
  }

  function trackCategoryView(rawType) {
    var category = normalizeCategory(rawType);
    if (!category) return;

    var tally = readTally();
    tally[category] = (tally[category] || 0) + 1;
    writeTally(tally);
  }

  function getTopCategory() {
    var tally = readTally();
    var topCategory = null;
    var topCount = 0;

    for (var category in tally) {
      if (!Object.prototype.hasOwnProperty.call(tally, category)) continue;
      var count = tally[category];
      if (typeof count === "number" && count > topCount) {
        topCount = count;
        topCategory = category;
      }
    }

    return topCategory;
  }

  function getTally() {
    var tally = readTally();
    var copy = {};
    for (var k in tally) {
      if (Object.prototype.hasOwnProperty.call(tally, k)) copy[k] = tally[k];
    }
    return copy;
  }

  function applyPersonalizedHero(root) {
    root = root || document;
    var heroEl = root.querySelector("[data-personalized-hero]");
    if (!heroEl) return;

    var topCategory = getTopCategory();
    if (!topCategory) return;

    var variantSelector =
      '[data-hero-variant="' + cssEscape(topCategory) + '"]';
    var variantEl = heroEl.querySelector(variantSelector);
    if (!variantEl) return;

    var imageUrl = variantEl.getAttribute("data-hero-image");
    var imageAlt = variantEl.getAttribute("data-hero-image-alt");
    var heading = variantEl.getAttribute("data-hero-heading");
    var ctaText = variantEl.getAttribute("data-hero-cta-text");
    var ctaHref = variantEl.getAttribute("data-hero-cta-href");

    var imageTarget = heroEl.querySelector("[data-hero-image-target]");
    var headingTarget = heroEl.querySelector("[data-hero-heading-target]");
    var ctaTarget = heroEl.querySelector("[data-hero-cta-target]");

    if (imageTarget && imageUrl) {
      imageTarget.setAttribute("src", imageUrl);
      if (imageAlt) imageTarget.setAttribute("alt", imageAlt);
    }
    if (headingTarget && heading) {
      headingTarget.textContent = heading;
    }
    if (ctaTarget && ctaText) {
      ctaTarget.textContent = ctaText;
      if (ctaHref) ctaTarget.setAttribute("href", ctaHref);
    }

    heroEl.setAttribute("data-hero-personalized-for", topCategory);
  }

  function cssEscape(value) {
    if (window.CSS && window.CSS.escape) return window.CSS.escape(value);
    return String(value).replace(/["\\]/g, "\\$&");
  }

  function init() {
    var autoTrackEl = document.querySelector("[data-track-category]");
    if (autoTrackEl) {
      trackCategoryView(autoTrackEl.getAttribute("data-track-category"));
    }

    applyPersonalizedHero(document);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  window.LBHPersonalization = {
    trackCategoryView: trackCategoryView,
    getTopCategory: getTopCategory,
    getTally: getTally,
    applyPersonalizedHero: applyPersonalizedHero,
  };
})(window, document);
